/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { skillsListSuggestions } from "../funcs/skillsListSuggestions.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListSkillSuggestionsRequest,
  ListSkillSuggestionsResponse,
  ListSkillSuggestionsSecurity,
} from "../models/operations/listskillsuggestions.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type SkillSuggestionsQueryData = ListSkillSuggestionsResponse;

export type SkillSuggestionsInfiniteQueryData = PageIterator<
  ListSkillSuggestionsResponse,
  { cursor: string }
>;

export type SkillSuggestionsPageParams = PageIterator<
  ListSkillSuggestionsResponse,
  { cursor: string }
>["~next"];

export function prefetchSkillSuggestions(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSkillSuggestionsRequest | undefined,
  security?: ListSkillSuggestionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSkillSuggestionsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchSkillSuggestionsInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSkillSuggestionsRequest | undefined,
  security?: ListSkillSuggestionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildSkillSuggestionsInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as SkillSuggestionsPageParams,
    getNextPageParam: (previousPage: SkillSuggestionsInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildSkillSuggestionsQuery(
  client$: GramCore,
  request?: ListSkillSuggestionsRequest | undefined,
  security?: ListSkillSuggestionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<SkillSuggestionsQueryData>;
} {
  return {
    queryKey: queryKeySkillSuggestions({
      skillId: request?.skillId,
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function skillSuggestionsQueryFn(
      ctx,
    ): Promise<SkillSuggestionsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(skillsListSuggestions(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildSkillSuggestionsInfiniteQuery(
  client$: GramCore,
  request?: ListSkillSuggestionsRequest | undefined,
  security?: ListSkillSuggestionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, SkillSuggestionsPageParams>,
  ) => Promise<SkillSuggestionsInfiniteQueryData>;
} {
  return {
    queryKey: queryKeySkillSuggestionsInfinite({
      skillId: request?.skillId,
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function skillSuggestionsQuery(
      ctx,
    ): Promise<SkillSuggestionsInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(skillsListSuggestions(
          client$,
          request,
          security,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(skillsListSuggestions(
        client$,
        {
          ...request!,
          cursor: ctx.pageParam.cursor,
        },
        security,
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeySkillSuggestions(
  parameters: {
    skillId?: string | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "skills", "listSuggestions", parameters];
}

export function queryKeySkillSuggestionsInfinite(
  parameters: {
    skillId?: string | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "skills", "listSuggestions", "infinite", parameters];
}
